var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('button',{on:{"click":function($event){return _vm.updateLabels()}}},[_vm._v("Update Labels")]),_c('apexcharts',{attrs:{"type":"donut","width":"280","options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }